<script lang="ts">
  import { CommonDto } from '@do/data-transfer-objects';
  import { DirectusImage, Preset } from '@do/svelte-directus-images';

  export let imgElement: HTMLImageElement;
  export let previewImage: CommonDto.Photo | null = null;
  export let title: string;
</script>

<DirectusImage
  imageData="{previewImage}"
  imgClasses="w-full"
  alt="{title}"
  pictureSizes="{{
    default: '100vw',
    'min-1024': '60vw',
    'min-1280': '67vw',
  }}"
  presetKeys="{Preset.Thumbnail}"
  loading="lazy"
  onErrorPlaceholderStatic="{{
    src: '/images/artwork-placeholder.png',
    width: 1000,
    height: 1000,
  }}"
  bind:imgElement
  on:load
/>
